module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-900-black-a67382169690ffa0b3c5da08314623c3.woff2";